import React from "react";

import styles from "./InstructionOverlay.module.css";



export default function InstrcutionOverlay() {
  return (
    <>
      <div  className={styles.ContainerBack}></div>
      <div  className={styles.ContainerFront}></div>
    </>
  );
}